"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
function initializeInboxRulesEditState() {
    return {
        ruleId: '',
        ruleName: '',
        conditionalClauseIds: [],
        actionClauseIds: [],
        exceptionClauseIds: [],
        clauseMap: mobx_1.map({}),
        clauseErrorTextMap: mobx_1.map({}),
        includesWordsInputTextMap: mobx_1.map({}),
        isSectionInfoCalloutVisible: mobx_1.map({}),
        focusedClauseId: '',
        ignoreSubsequentRules: true,
        selectedFolderId: '',
    };
}
exports.default = initializeInboxRulesEditState;
//# sourceMappingURL=initializeInboxRulesEditState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/initializeInboxRulesEditState.js
// module id = 3176
// module chunks = 2 90